import { AlertTriangle } from "lucide-react";
import { ReactNode } from "react";

interface AlarmBannerProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export function AlarmBanner({ children, icon, className = "" }: AlarmBannerProps) {
  return (
    <div className={`alarm-banner flex items-start gap-3 ${className}`}>
      <div className="flex-shrink-0 mt-0.5">
        {icon || <AlertTriangle className="w-5 h-5 text-amber-400" />}
      </div>
      <div className="flex-1 text-sm">
        {children}
      </div>
    </div>
  );
}
